// extracted by mini-css-extract-plugin
export default {"container":"static-data_container__8WJi1","title":"static-data_title__2KJAf"};